import { useState } from 'react';
import { SpaceType } from '@tribeplatform/gql-client/types';
import { useAuthToken, useSpaces } from '@tribeplatform/react-sdk/hooks';
import { simplifyPaginatedResult } from '@tribeplatform/react-sdk/utils';
import { useDebounce } from '../../common/hooks/useDebounce';
import { useI18n } from '../../i18n';
const useStaticSpaceItems = () => {
    const intl = useI18n();
    const { data: authToken } = useAuthToken();
    const { networkPublicInfo } = authToken || {};
    const EntireCommunityItem = {
        id: null,
        image: networkPublicInfo.favicon,
        name: intl.$t({
            defaultMessage: 'Entire {COMMUNITY}',
            id: 'Space.PagePicker.EntireCommunity',
        }),
    };
    const CurrentSpaceItem = {
        id: '{{ spaceId }}',
        image: networkPublicInfo.favicon,
        name: intl.$t({
            defaultMessage: 'Current {SPACE}',
            id: 'Space.PagePicker.CurrentSpace',
        }),
    };
    return { EntireCommunityItem, CurrentSpaceItem };
};
export const usePagePicker = ({ initialPage, currentSpaceId, onSelect, }) => {
    const [search, setSearch] = useState('');
    const { EntireCommunityItem, CurrentSpaceItem } = useStaticSpaceItems();
    const [selectedPage, setSelectedPage] = useState(() => {
        if (initialPage.id === EntireCommunityItem.id) {
            return EntireCommunityItem;
        }
        if (initialPage.id === CurrentSpaceItem.id) {
            return CurrentSpaceItem;
        }
        return initialPage;
    });
    const debouncedQuery = useDebounce(search, 300);
    const { data, isLoading } = useSpaces({
        fields: { image: 'basic' },
        variables: {
            query: debouncedQuery,
            limit: 20,
            type: [SpaceType.Group],
        },
    });
    const { nodes: spacePages } = simplifyPaginatedResult(data);
    const options = [
        EntireCommunityItem,
        ...(currentSpaceId ? [CurrentSpaceItem] : []),
        ...spacePages,
    ];
    const onChange = value => {
        setSelectedPage(value);
        onSelect(value);
    };
    return {
        options,
        selectedPage,
        isLoading,
        search,
        setSearch,
        onChange,
    };
};
//# sourceMappingURL=usePagePicker.js.map